const cabinetBulkEditTraitVisibleBehavior = async (source, content, parentContentPath, transientContext
// nativeFunctions,
// sourceEvaluator,
) => {
  const {
    selection = {}
  } = transientContext;
  const formTypeIdentifiers = Object.keys(selection);
  return formTypeIdentifiers.length === 1 && formTypeIdentifiers[0] === source.value;
};
module.exports = {
  evaluate: cabinetBulkEditTraitVisibleBehavior
};